import React from 'react';
import { getOr, map, size } from 'lodash/fp';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Icon,
  Input,
  InputGroup,
  DateRangePicker,
  CheckPicker,
  Button
} from 'rsuite';

const VisitSearch = ({
  locationOptions,
  queryOptions,
  searchQuery,
  placeholder,
  onChange,
  onSubmit,
  onReset,
  isFetching
}) => {
  const { q: query } = queryOptions;
  const handleOnChange = q => {
    onChange({ ...searchQuery, q });
  };

  const handleVisitDateChange = value => {
    const updatedQuery = { ...searchQuery, visit_on: value };
    onChange(updatedQuery);
    onSubmit({ ...queryOptions, ...updatedQuery });
  };

  const handleLocationChange = value => {
    if (!size(value)) return;
    const updatedQuery = { ...searchQuery, location_id: value };
    onChange(updatedQuery);
    onSubmit({ ...queryOptions, ...updatedQuery });
  };

  const handleOnReset = () => {
    const defaultQuery = {
      ...searchQuery,
      q: '',
      visit_on: [],
      location_id: map('value', locationOptions)
    };
    onReset(defaultQuery);
  };

  return (
    <Grid fluid style={{ padding: 0, marginLeft: 0 }}>
      <Row gutter={8}>
        <Col xs={24} md={8} lg={8}>
          <InputGroup>
            <Input
              value={query}
              onChange={handleOnChange}
              style={{ paddingLeft: 10 }}
              placeholder={placeholder}
              disabled={isFetching}
              onKeyPress={({ key }) => {
                if (key === 'Enter') onSubmit(queryOptions);
              }}
            />
            <InputGroup.Button
              style={{ borderBottom: 'none' }}
              disabled={!query || isFetching}
              onClick={() => {
                if (query !== '') onSubmit(queryOptions);
              }}
            >
              <Icon icon="search" />
            </InputGroup.Button>
          </InputGroup>
        </Col>
        <Col xs={24} md={6}>
          <DateRangePicker
            style={{ width: '100%', marginRight: 10 }}
            value={getOr([], 'visit_on', queryOptions)}
            placeholder="Select Visit Date Range"
            onChange={handleVisitDateChange}
            disabled={isFetching}
          />
        </Col>
        {size(locationOptions) > 1 && (
          <Col xs={24} md={6}>
            <CheckPicker
              style={{ width: '100%', marginRight: 10 }}
              value={getOr([], 'location_id', queryOptions)}
              data={locationOptions}
              placeholder="Select Location"
              onChange={handleLocationChange}
              disabled={isFetching}
            />
          </Col>
        )}
        <Col sm={24} md={4} lg={3}>
          <Button
            style={{ borderBottom: 'none', marginRight: 10 }}
            onClick={handleOnReset}
            disabled={isFetching}
          >
            <Icon icon="refresh" /> Reset
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};

VisitSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  searchQuery: PropTypes.shape({
    q: PropTypes.string,
    client_id: PropTypes.number,
    visit_on: PropTypes.arrayOf(PropTypes.shape({})),
    location_id: PropTypes.arrayOf(PropTypes.number)
  }),
  queryOptions: PropTypes.shape({
    q: PropTypes.string,
    client_id: PropTypes.number,
    visit_on: PropTypes.arrayOf(PropTypes.shape({})),
    location_id: PropTypes.arrayOf(PropTypes.number),
    limit: PropTypes.number,
    page: PropTypes.number,
    order: PropTypes.string
  }),
  locationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired
};

VisitSearch.defaultProps = {
  searchQuery: {},
  queryOptions: {}
};

export default VisitSearch;
